import { getRootDomain } from "PFCore/helpers/root_domain";

const ROOT = "account";
const MY_ACCOUNT_INFO = "myAccountInfo";

export const accountKeys = {
  single: (domain) => [ROOT, domain],
  basic: () => accountKeys.single(getRootDomain()),
  myAccountInfo: () => [...accountKeys.basic(), MY_ACCOUNT_INFO]
};
